<div class="channel-form-container">
  <div class="header-and-form-container">
    <div class="header-container" mat-dialog-title>
      <div class="header-title">
        {{ isUpdate ? "Editar canal" : "Novo canal" }}
      </div>
      <div class="header-close" mat-dialog-close>
        <span class="material-icons icon-close"> close </span>
      </div>
    </div>
    <mat-dialog-content>
      <div class="form-container">
        <div class="title-form-field">Informações gerais</div>
        <form [formGroup]="formGroup">
          <!--  name -->
          <div class="select-fields">
            <mat-form-field appearance="outline">
              <mat-label>Nome do canal</mat-label>
              <input
                matInput
                formControlName="name"
                placeholder="Nome do canal"
              />
              <mat-error *ngIf="formGroup.get('name')?.hasError('required')">
                Informe o nome do canal
              </mat-error>
            </mat-form-field>
          </div>

          <!-- employees -->
          <div class="select-fields pointer">
            <mat-form-field
              appearance="outline"
              (click)="openList($event, triggerResponsable)"
            >
              <mat-label>Atendentes</mat-label>

              <input
                #triggerResponsable="matAutocompleteTrigger"
                type="text"
                placeholder="Atendente"
                aria-label="Atendente"
                matInput
                formControlName="employees"
                [matAutocomplete]="autoEmployee"
                readonly
              />

              <span
                matSuffix
                class="material-icons"
                *ngIf="!autoEmployee.isOpen"
              >
                expand_more
              </span>

              <span
                matSuffix
                class="material-icons"
                *ngIf="autoEmployee.isOpen"
              >
                expand_less
              </span>

              <mat-autocomplete #autoEmployee="matAutocomplete">
                <mat-option [style.display]="'none'"></mat-option>
                <app-select-simple-list
                  [searchPlaceHolder]="employeePlaceholder"
                  [selectAllText]="selectAllEmployees"
                  [list]="employees"
                  (selectEvent)="handleEmployeesSelect($event)"
                  [hideButtons]="true"
                >
                </app-select-simple-list>
              </mat-autocomplete>
              <mat-error
                *ngIf="formGroup?.get('employees')?.hasError('required')"
              >
                Selecione um Atendente
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Descrição (Opcional)</mat-label>
              <textarea
                matInput
                formControlName="description"
                rows="4"
              ></textarea>
            </mat-form-field>
          </div>

          <div class="title-form-field">
            Segmentação
            <mat-icon
              aria-hidden="false"
              aria-label="info"
              color="primary"
              matTooltip="Ao remover algum perfil e/ou turma do canal, todo o histórico de conversas referentes a eles será perdido, não sendo possível recuperá-lo."
              matTooltipPosition="above"
              matTooltipClass="custom-tooltip"
              >info_outline</mat-icon
            >
          </div>

          <div class="year-classrooms">
            <!-- year -->
            <div class="year">
              <app-school-year-combo
                class="year"
                [txtYear]="startTxtYear"
                (yearSelected)="handleYearSelected($event)"
              >
              </app-school-year-combo>
            </div>

            <!-- profiles -->
            <div class="select-fields pointer">
              <mat-form-field
                appearance="outline"
                (click)="openList($event, triggerProfile)"
              >
                <mat-label>Perfil de acesso</mat-label>

                <input
                  #triggerProfile="matAutocompleteTrigger"
                  type="text"
                  placeholder="Perfis de acesso"
                  aria-label="Perfis de acesso"
                  matInput
                  formControlName="profiles"
                  [matAutocomplete]="autoProfile"
                  readonly
                />

                <span
                  matSuffix
                  class="material-icons"
                  *ngIf="!autoProfile.isOpen"
                >
                  expand_more
                </span>

                <span
                  matSuffix
                  class="material-icons"
                  *ngIf="autoProfile.isOpen"
                >
                  expand_less
                </span>

                <mat-autocomplete #autoProfile="matAutocomplete">
                  <mat-option [style.display]="'none'"></mat-option>
                  <app-profile-simple-list
                    [selectAllText]="selectAll"
                    [initialIdProfiles]="idsProfiles"
                    (selectEvent)="handleProfilesSelect($event)"
                    [hidePhoto]="true"
                    [excludeProfiles]="excludeProfiles"
                    [hideButtons]="true"
                  >
                  </app-profile-simple-list>
                </mat-autocomplete>
                <mat-error
                  *ngIf="
                    formGroup.get('profiles')?.hasError('required') &&
                    (formGroup.get('profiles')?.dirty ||
                      formGroup.get('profiles')?.touched)
                  "
                >
                  Selecione um Perfil de acesso
                </mat-error>
              </mat-form-field>
            </div>

            <!-- class-rooms -->
            <div class="select-fields pointer">
              <mat-form-field
                appearance="outline"
                (click)="hasClassrooms && openList($event, triggerClassroom)"
              >
                <mat-label>Turma(s)</mat-label>
                <input
                  #triggerClassroom="matAutocompleteTrigger"
                  type="text"
                  placeholder="Turmas Liberadas"
                  aria-label="Turmas Liberadas"
                  matInput
                  formControlName="classrooms"
                  [matAutocomplete]="autoClassroom"
                  readonly
                />

                <span
                  matSuffix
                  class="material-icons"
                  *ngIf="hasClassrooms && !autoClassroom.isOpen"
                >
                  expand_more
                </span>

                <span
                  matSuffix
                  class="material-icons"
                  *ngIf="hasClassrooms && autoClassroom.isOpen"
                >
                  expand_less
                </span>

                <mat-autocomplete #autoClassroom="matAutocomplete">
                  <mat-option [style.display]="'none'"></mat-option>
                  <app-select-hierarquical-list
                    *ngIf="segmentTreeData && segmentTreeData.length > 0"
                    [treeData]="segmentTreeData"
                    [initialSelection]="channel ? channel.idsClassRooms : []"
                    (selectEvent)="handleClassroomSelect($event)"
                    (deSelectEvent)="handleDeselected($event)"
                    [hideButtons]="true"
                  ></app-select-hierarquical-list>
                </mat-autocomplete>

                <mat-error
                  *ngIf="formGroup?.get('classrooms')?.hasError('required')"
                >
                  Selecione uma Turma
                </mat-error>
              </mat-form-field>
            </div>

            <app-attention-alert
              *ngIf="!hasClassrooms"
              [message]="alertMessage"
            >
            </app-attention-alert>

            <!-- ticket info-->
            <div class="title-form-field" *ngIf="hasTicketsFeatures()">
              Atendimentos Monitorados
              <div class="icon-text-date-cell-toggle">
                <mat-slide-toggle
                  formControlName="ticketFunctionality"
                  (click)="onClick($event)"
                  (change)="onChange($event)"
                  [checked]="isChecked()"
                >
                </mat-slide-toggle>
              </div>
            </div>

          </div>
        </form>
      </div>
    </mat-dialog-content>
  </div>

  <mat-dialog-actions align="center">
    <div class="footer-container">
      <button mat-raised-button class="btn-cancel" mat-dialog-close>
        Cancelar
      </button>
      <div class="divider"></div>
      <button
        mat-raised-button
        class="btn-save"
        [disabled]="formGroup.invalid || !formGroup.dirty || !hasClassrooms"
        (click)="saveChannel()"
      >
        {{ !isUpdate ? "Criar" : "Salvar" }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
